import React from "react";
import { Box, Button, DialogActions, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BatchStep, BatchStepWithSort } from "@beable/roster-backend-client-v1";
import { getStyles } from "../styles";
import { AddCircle, RadioButtonUnchecked, RemoveCircle } from "@mui/icons-material";
import BaseDialog from "../../Common/BaseDialog";

interface SummaryProps {
    open: boolean;
    onClose: () => void;
    currentSteps: BatchStepWithSort[];
    addedSteps: BatchStepWithSort[];
    deletedSteps: BatchStepWithSort[];
    saveSteps: () => void;
}

export const SiteBatchStepsSummary = ({
    open,
    onClose,
    currentSteps,
    addedSteps,
    deletedSteps,
    saveSteps
}: SummaryProps) => {
    const theme = useTheme();
    const styles = getStyles(theme);
    const DeletedListItem = (step: BatchStep, index: number) => (
        <ListItem key={index} disablePadding sx={styles.deletedStep}>
            <ListItemIcon>
                <RemoveCircle sx={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText primary={step.name} />
        </ListItem>
    )
    const AddedListItem = (step: BatchStep, index: number) => (
        <ListItem key={index} disablePadding sx={styles.addedStep}>
            <ListItemIcon>
                <AddCircle sx={{ color: "green" }} />
            </ListItemIcon>
            <ListItemText primary={step.name} />
        </ListItem>
    )
    const UnchangedListItem = (step: BatchStep, index: number) => (
        <ListItem key={index} disablePadding >
            <ListItemIcon>
                <RadioButtonUnchecked />
            </ListItemIcon>
            <ListItemText primary={step.name} />
        </ListItem>
    )
    return (
        <BaseDialog
            showCloseIcon={false}
            showCloseButton={false}
            open={open}
            onClose={onClose}
            header={'Summary'}
        >
            <Typography variant="h6">The following steps will be saved</Typography>
            {!addedSteps.length && !deletedSteps.length ? <Typography variant="subtitle2">(Reordering existing steps)</Typography> : undefined}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%"
                }}>
                <List data-testid='current-list'>
                    {(currentSteps).map((step, index) =>
                        addedSteps.includes(step) ? AddedListItem(step.batchStep, index) : UnchangedListItem(step.batchStep, index)
                    )}
                </List>
            </Box>
            {deletedSteps.length ?
                <>
                    <Typography sx={styles.mt2} variant="h6" >The following steps will be deleted</Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%"
                        }}>
                        <List data-testid='deleted-list'>
                            {(deletedSteps).map((step, index) =>
                                DeletedListItem(step.batchStep, index)
                            )}
                        </List>
                    </Box>
                </> : undefined
            }
            <DialogActions>
                <Button
                    variant='outlined'
                    color='secondary'
                    aria-label='cancel'
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    aria-label='save'
                    onClick={saveSteps}
                >
                    Save
                </Button>

            </DialogActions>
        </BaseDialog>
    );
};